import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface AlertDialogProps {
  openDialog: boolean;
  setOpenDialog: Dispatch<SetStateAction<boolean>>;
  title?: string;
  description: string;
  action: () => void;
  cancelVisible: boolean;
}

const AlertDialog = ({
  openDialog,
  setOpenDialog,
  title,
  description,
  action,
  cancelVisible,
}: AlertDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={openDialog}
      onClose={() => setOpenDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button data-test="alert-dialog-ok-button" onClick={action} autoFocus>
          {t("alert_dialog.ok")}
        </Button>
        {cancelVisible && (
          <Button
            data-test="alert-dialog-cancel-button"
            onClick={() => setOpenDialog(false)}
          >
            {t("alert_dialog.cancel")}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
